import { render, staticRenderFns } from "./logTable.vue?vue&type=template&id=58fb434f&scoped=true"
import script from "./logTable.vue?vue&type=script&lang=js"
export * from "./logTable.vue?vue&type=script&lang=js"
import style0 from "./logTable.vue?vue&type=style&index=0&id=58fb434f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb434f",
  null
  
)

export default component.exports